import * as React from "react";
function ArrowRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.43 21a.38.38 0 01-.287-.132.398.398 0 01.035-.553l8.815-7.924H3.383A.387.387 0 013 12c0-.216.172-.391.383-.391h16.608l-8.814-7.924A.394.394 0 0111.43 3c.094 0 .183.034.253.098l8.925 8.022a1.165 1.165 0 01.382.804.291.291 0 01.005.127v.022c-.02.314-.158.6-.387.808l-8.924 8.022a.379.379 0 01-.253.097z"
  }));
}
const ForwardRef = React.forwardRef(ArrowRightIcon);
export default ForwardRef;